import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
/**
 * Stats footer rendered at the bottom of the index page. Reads counts
 * from the forum payload (respawnPostCount, respawnDiscussionCount,
 * respawnMemberCount, respawnOnlineCount) which ForumStatistics
 * computes server-side at a 60s cache.
 *
 * Null values render as the "empty" glyph rather than a misleading 0 — the
 * cached computation can fail (DB blip) and we'd rather show that than lie.
 */
export default class RespawnStats extends Component {
  view() {
    const fmt = n => {
      if (n == null) return app.translator.trans('ernestdefoe-respawn.forum.stats.empty');
      return new Intl.NumberFormat().format(n);
    };
    const posts = app.forum.attribute('respawnPostCount');
    const discussions = app.forum.attribute('respawnDiscussionCount');
    const members = app.forum.attribute('respawnMemberCount');
    const online = app.forum.attribute('respawnOnlineCount');
    return m('section.RespawnStats', [m('h3.RespawnStats-title', [m('span.arrow', '▸'), ' ', app.translator.trans('ernestdefoe-respawn.forum.stats.title')]), m('.RespawnStats-grid', [this.card('◆', app.translator.trans('ernestdefoe-respawn.forum.stats.posts'), fmt(posts)), this.card('◇', app.translator.trans('ernestdefoe-respawn.forum.stats.discussions'), fmt(discussions)), this.card('⬢', app.translator.trans('ernestdefoe-respawn.forum.stats.members'), fmt(members)), this.card('▶', app.translator.trans('ernestdefoe-respawn.forum.stats.online'), fmt(online), true)])]);
  }
  card(glyph, label, value, live = false) {
    return m('.RespawnStats-card', [m('.RespawnStats-label', [m('span.glyph', glyph), ' ', label]), m('.RespawnStats-value', value), live ? m('.RespawnStats-delta.live', app.translator.trans('ernestdefoe-respawn.forum.stats.live')) : null]);
  }
}
flarum.reg.add('ernestdefoe-respawn', 'forum/components/RespawnStats', RespawnStats);